import t from "moment";
const m = "YYYY-MM-DDTHH:mm:ss";
function n(e) {
  return t(e, m);
}
export {
  n as default
};
